<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称或者条形码" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select v-model="pid" @change="searchClass()" filterable  placeholder="选择二级分类查询" style="margin-right:20px;" clearable>
                <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id" ></el-option>
            </el-select>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url"  />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="name"  label="商品类型" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="status" align="center" label="商品状态">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.status == 1">已上架</el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="updated_at"  align="center" label="操作时间" ></el-table-column> -->
                <el-table-column prop="visits"      align="center" label="浏览量" ></el-table-column>
                <el-table-column  prop="sales_volume" align="center" label="商品销量"  sortable>
                    <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.sales_volume" @change="handleSales(scope.row)" size="mini" style="width:80px" readonly></el-input>
                    </template> -->
                </el-table-column>
                <el-table-column prop="belongs"      align="center" label="商品归属" >
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.belongs == '1'">自营</el-link>
                        <el-link type="warning" v-else-if="scope.row.belongs == '2'">供应商</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button v-if="scope.row.status == 1" @click="$router.push({path: `/goods/mooby/edit/${scope.row.id}`})" type="primary" plain size="mini">修改商品</el-button>
                            <el-button v-if="scope.row.is_google_shopping == 0" @click="addGoogle(scope.row)" type="success" plain size="mini">上架Google</el-button>
                            <el-button v-if="scope.row.is_google_shopping == 1" @click="delGoogle(scope.row)" type="danger" plain size="mini">下架Google</el-button>
                            <el-button v-if="scope.row.status == 1" @click="goodsEdit(scope.row, 2)" type="danger" plain size="mini">下架商品</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="主题展示">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button v-if="scope.row.is_recommend == 0" type="success" plain size="mini" @click="handleAdd(1,scope.row)">为你推荐</el-button>
                            <el-button v-if="scope.row.is_now == 0" type="primary" plain size="mini" @click="handleAdd(2,scope.row)">新品首发</el-button>
                            <el-button v-if="scope.row.is_hot_sales == 0" type="warning" plain size="mini" @click="handleAdd(3,scope.row)">热销产品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size" ></el-pagination>
        </el-card>



    </div>
</template>



<script>
/* eslint-disable */
import { goods_list, goods_status, add_columns, classify_list, add_google, del_google } from '@/api/goods.js'
import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            page:1,
            size: 20,
            goods_modal:false,
            sku:[],
            goodsId:'',                   //商品ID
            pid: '',
            options: [],
            sku_title: '',
            sku_modal: false,
        }
    },
    methods: {
        search() {
            this.page = 1
            this.getData()
        },
        searchClass() {
            this.page = 1;
            this.getData()
        },
        // 获取分类数据
        getFirst(){
            let params = {
                level:2 
            }
            classify_list(params).then(res => {
                if(res) {
                    this.options = res.data
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
                status: 1,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            if(this.pid != "") {
                params.type_id = this.pid
            }
            goods_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        // 上传谷歌
        addGoogle(row) {
            add_google(row.id).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData();
                }
            })
        },
        // 下架谷歌
        delGoogle(row) {
            del_google(row.id).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData();
                }
            })
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
        // 监听选中 table 事件 
        handleSelectionChange(rows){
            this.checkData = rows
        },
        editRow(id){
            this.goodsId= id ;
            let params = {
                goods_id:id
            }
            goodssku(params).then(res => {
                if(res.status == 1){
                    this.sku = res.msg;
                    this.goods_modal = true;
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        // 添加为你推荐、新品首发、热销产品
        handleAdd(e,row) {
            let params = {
                goods_id:row.id,
                column: e
            }
            add_columns(params).then(res => {
                if(res) {
                    this.$message({type:'success',message:res.msg})
                    if(e == 1) {
                        row.is_recommend = 1
                    } else if(e == 2) {
                        row.is_now = 1
                    } else {
                        row.is_hot_sales = 1
                    }
                }
            })
        }
    },
    created(){
        this.getFirst();
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.goods-list {
    .table-btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-button {
            margin-bottom: 5px;
        }
        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
</style>
